export default __webpack_public_path__ + "static/media/Roboto-Regular.d3566b3c.ttf";